import * as React from 'react';
import * as moment from 'moment';

import LazyImage from '../../components/lazy-image';

import { ListEventProps } from '../../components/list/event';

const ListEventView: React.StatelessComponent<ListEventProps> = props => {
    const eventMoment = moment(props.event.eventDate);

    return (
        <li className="ace-cal-list-event">
            <article className="stack-sm" aria-label={`${props.event.name} on ${eventMoment.format("dddd MMMM D")} at ${props.event.eventTimeString}`}>
                <h4 className="h2-secondary">{eventMoment.format("MMMM D | dddd")}</h4>
                <div className="ace-cal-list-event-content">
                    <div className="ace-cal-list-event-image">
                        {
                            props.event.thumbnail &&
                            <LazyImage role="presentation" src={props.event.thumbnail} alt="" className="ace-cal-list-event-image-img" />
                        }
                    </div>
                    <div className="ace-cal-list-event-details stack">
                        <div className="stack-sm">
                            <p className="h1-secondary">{props.event.name}</p>
                            <p className="ace-cal-list-event-time h2-secondary">{props.event.eventTimeString}</p>
                            <p className="h3-secondary">{props.event.location}</p>
                        </div>
                        {
                            props.event.synopsis.length > 0 &&
                            <div className="rich-text small"><p>{props.event.synopsis}</p></div>
                        }
                        {props.event.hideCta ? null
                            : <p className="ace-cal-list-event-cta"><a href={props.event.buyTicketCtaUrl} className="btn-outline">{props.event.buyTicketCtaText ? props.event.buyTicketCtaText : props.text.buyTicketCtaDefaultText}</a></p>
                        }
                        {props.event.listAvailabilityStatus ?
                            <p className="ace-cal-list-status small light" dangerouslySetInnerHTML={{ __html: props.event.listAvailabilityStatus }} />
                            : null}
                        {props.event.listInformationStatus ?
                            <p className="ace-cal-list-status small light" dangerouslySetInnerHTML={{ __html: props.event.listInformationStatus }} />
                            : null}
                    </div>
                </div>
            </article>
        </li>
    );
}

export default ListEventView;